import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  // --------------EasyInest-----------------
  REQAnalyticList,
  RESAnalyticList,
  FailAnalyticList,
  // --------------UntHld-----------------
  REQAnalyticUntHldList,
  RESAnalyticUntHldList,
  FailAnalyticUntHldList,
  // --------------PVD-----------------
  REQAnalyticPVDList,
  RESAnalyticPVDList,
  FailAnalyticPVDList,
  // --------------PVD Excel Download-----------------
  REQAnalyticPVDExcelDownload,
  RESAnalyticPVDExcelDownload,
  FailAnalyticPVDExcelDownload
} from "./actions";
import moment from "moment";
import * as actions from "../../Authentication/redux/actions";

function* fetchAnalyticListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUserAccount`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticList(response));
    } else {
      yield put(RESAnalyticList());
    }
  } catch (error) {

    yield put(FailAnalyticList());
  }
}

function* fetchAnalyticUntHldListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD } = payload;
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    let tEndD1 = moment(tEndD).format("YYYY-MM-DD");
    tEndD1 = tEndD1 + " 23:59";
    const request = yield fetch(
      `${process.env.REACT_APP_API_ADMIN_URL}/api/v1/admin/analyticUnitHolder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userid: tGUID,
          'x-id-token': "Bearer " + accessToken
        },
        body: JSON.stringify({
          // ---Search----
          startDate: tStartD1,
          endDate: tEndD1,
          allDate: bAllD
        })
      }
    );
    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    const response = yield request.json();

    if (response) {
      yield put(RESAnalyticUntHldList(response));
    } else {
      yield put(RESAnalyticUntHldList());
    }
  } catch (error) {

    yield put(FailAnalyticUntHldList());
  }
}

function* fetchAnalyticPVDListWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, page = 1, per_page = 50, sort_by = 'B2C_CreateDate', sort_order = 'asc' } = payload;

    // Format dates as YYYY-MM-DD
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    const tEndD1 = moment(tEndD).format("YYYY-MM-DD");

    // Build query parameters
    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      start_date: tStartD1,
      end_date: tEndD1,
      sort_by: sort_by,
      sort_order: sort_order    });    // ============================================================
    // REAL API MODE - Mock data disabled
    // ============================================================// ============================================================
    // REAL API CALL
    // ============================================================
    const apiUrl = `/api/pvd/pvd-report?${queryParams.toString()}`;

    console.log('🔵 PVD API Call (via proxy) [REAL API]:', apiUrl);
    console.log('📦 Payload:', { tStartD1, tEndD1, page, per_page, sort_by, sort_order });
    console.log('🕐 Timestamp:', new Date().toISOString());

    // ============================================================
    // Authorization header - Set manually in browser DevTools or use network interceptor
    // ============================================================
    const authHeaders = {
      "Content-Type": "application/json",
      "Authorization": "" // Leave blank - add token manually in browser
    };

    const request = yield fetch(apiUrl, {
      method: "GET",
      headers: authHeaders
    });

    console.log('📡 API Response Status:', request.status);
    console.log('📋 Response Headers:', {
      contentType: request.headers.get('content-type'),
      corsHeaders: {
        accessControlAllowOrigin: request.headers.get('access-control-allow-origin'),
        accessControlAllowMethods: request.headers.get('access-control-allow-methods')
      }
    });    if (request.status === 401 || request.status === 403) {
      console.log('❌ Unauthorized/Forbidden:', request.status);
      console.log('💡 Check the authorization header format with backend team');
      console.log('💡 Add Authorization token manually using ModHeader or DevTools');
      // Commented out auto sign-out for manual testing
      // yield put(actions.autoSignOut());
      yield put(FailAnalyticPVDList());
      return;
    }

    // Check if response is JSON
    const contentType = request.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      console.error('❌ Response is not JSON, content-type:', contentType);
      const textResponse = yield request.text();
      console.error('❌ Response body (first 500 chars):', textResponse.substring(0, 500));
      yield put(FailAnalyticPVDList());
      return;
    }

    const response = yield request.json();
    console.log('✅ API Response Data:', response);

    if (response && response.data) {
      yield put(RESAnalyticPVDList(response.data));
    } else if (response) {
      yield put(RESAnalyticPVDList(response));
    } else {
      yield put(RESAnalyticPVDList());
    }
  } catch (error) {
    console.error('❌ PVD API Error:', error);
    yield put(FailAnalyticPVDList());
  }
}

function* fetchAnalyticPVDExcelDownloadWorker({ payload }) {
  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const { tStartD, tEndD, bAllD, sort_by = 'B2C_CreateDate', sort_order = 'asc' } = payload;

    // Format dates as YYYY-MM-DD
    const tStartD1 = moment(tStartD).format("YYYY-MM-DD");
    const tEndD1 = moment(tEndD).format("YYYY-MM-DD");    // Build query parameters for FULL DATA (no pagination)
    const queryParams = new URLSearchParams({
      start_date: tStartD1,
      end_date: tEndD1,
      sort_by: sort_by,
      sort_order: sort_order,
      export: 'true' // Flag to indicate we want all data
    });

    // ============================================================
    // REAL API MODE - Mock data disabled for Excel download
    // ============================================================
    // ============================================================
    // REAL API CALL - Fetch ALL data without pagination
    // ============================================================
    const apiUrl = `${process.env.REACT_APP_API_ADMIN_URL}/api/pvd/pvd-report?${queryParams.toString()}`;

    console.log('🔵 PVD Excel Download API Call [REAL API]:', apiUrl);
    console.log('📦 Payload:', { tStartD1, tEndD1, sort_by, sort_order });

    const authHeaders = {
      "Content-Type": "application/json",
      "Authorization": "" // Leave blank - add token manually in browser
    };

    const request = yield fetch(apiUrl, {
      method: "GET",
      headers: authHeaders
    });

    console.log('📡 Excel Download API Response Status:', request.status);    if (request.status === 401 || request.status === 403) {
      console.log('❌ Unauthorized/Forbidden:', request.status);
      console.log('💡 Add Authorization token manually using ModHeader or DevTools');
      // Commented out auto sign-out for manual testing
      // yield put(actions.autoSignOut());
      yield put(FailAnalyticPVDExcelDownload());
      return null;
    }

    const contentType = request.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      console.error('❌ Response is not JSON, content-type:', contentType);
      yield put(FailAnalyticPVDExcelDownload());
      return null;
    }

    const response = yield request.json();
    console.log('✅ Excel Download API Response Data:', response);

    let allData = [];
    if (response && response.data && response.data.results) {
      allData = response.data.results;
    } else if (response && response.results) {
      allData = response.results;
    }

    yield put(RESAnalyticPVDExcelDownload(allData));
    return allData;
  } catch (error) {
    console.error('❌ PVD Excel Download Error:', error);
    yield put(FailAnalyticPVDExcelDownload());
    return null;
  }
}

export function* analyticListSaga() {
  yield all([
    takeLatest(REQAnalyticList, fetchAnalyticListWorker),
    takeLatest(REQAnalyticUntHldList, fetchAnalyticUntHldListWorker),
    takeLatest(REQAnalyticPVDList, fetchAnalyticPVDListWorker),
    takeLatest(REQAnalyticPVDExcelDownload, fetchAnalyticPVDExcelDownloadWorker)
  ]);
}